import { forEach, find } from 'lodash';
/**
 * 存放所有路由数据
 */

var RoutersStorage = [];
/**
 * 路由管理器
 *
 * 用于管理注册的所有路由
 */

var RoutesManager = function () {
  function RoutesManager() {}
  /**
   * 注册路由
   *
   * 路由中的节点 path 相同时进行节点合并，否则将新增路由节点添加至原始路由中
   *
   * @param desc 路由元数据
   */


  RoutesManager.register = function (desc) {
    combineRoutes(RoutersStorage, desc);
  };
  /**
   * 清除全部路由记录
   */


  RoutesManager.clear = function () {
    RoutersStorage.length = 0;
  };
  /**
   * 获取所有路由配置
   */


  RoutesManager.getRoutes = function () {
    return RoutersStorage;
  };

  return RoutesManager;
}();

export { RoutesManager };
/**
 * 合并原始路由和新增路由
 *
 * 原始路由和新增路由中的节点 path 相同时进行节点合并，否则将新增路由节点添加至原始路由中。
 *
 * @param origin 原始路由
 * @param routes 新增路由
 */

function combineRoutes(origin, routes) {
  forEach(routes, function (route) {
    var originRoute = find(origin, {
      path: route.path
    });

    if (originRoute) {
      if (!originRoute.childRoutes) {
        originRoute.childRoutes = [];
      }

      if (route.childRoutes) {
        combineRoutes(originRoute.childRoutes, route.childRoutes);
      }
    } else {
      origin.push(route);
    }
  });
}